import React from 'react';

/**
 * Small numbered eyebrow. Pass `as="h1"` on page heroes: the keyword-bearing
 * eyebrow becomes the document H1 while the display headline stays visual.
 */
export function SectionLabel({ num, children, as: As = 'div', className = '', 'data-testid': testId }) {
  return (
    <div
      data-testid={testId}
      className={`nd-mono flex items-center gap-4 ${className}`}
    >
      <span aria-hidden={As !== 'div' || undefined} className="text-ink-text tabular-nums">{num}</span>
      <span aria-hidden className="h-px w-12 bg-white/15" />
      <As className="nd-mono font-normal" style={{ fontFamily: 'var(--f-mono)' }}>{children}</As>
    </div>
  );
}
